module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/desktop/jobs-8c66d3755c7ff9383c75b52eb6148748.jpg";